import React, { createContext, useContext } from "react";
import useOciConfigHook from "../../../hooks/Dashboard/oci/useConfig";

export const OciConfigContext = createContext();

export const OciConfigProvider = ({ children }) => {
  const data = useOciConfigHook();
  return (
    <OciConfigContext.Provider value={data}>
      {children}
    </OciConfigContext.Provider>
  );
};

export const useOciConfig = () => useContext(OciConfigContext);
